module.exports = __webpack_public_path__ + "static/media/header_ball.5e6dd8f0.svg";